import React from 'react';
import classNames from 'classnames';
import { SIZES } from '../../constants/icons';

const Icon = ({ icon, className, size = SIZES.S }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${SIZES.XXS} ${SIZES.XXS}`}
    className={classNames('fill-current  hover:opacity-70', className)}
  >
    <path d={icon} />
  </svg>
);

export default Icon;
